import { gql } from '@apollo/client';

export * from './requestExclusiveOffer.mutation.generated';

export const REQUEST_EXCLUSIVE_OFFER = gql`
  mutation requestExclusiveOffer($clientMutationId: String) {
    requestExclusiveOffer(input: { clientMutationId: $clientMutationId }) {
      success
      errors
    }
  }
`;
